'use strict';

export default class AddController {

  /*@ngInject*/
  constructor($http, $state, Upload, toaster) {
    this.$http = $http;
    this.$state = $state;
    this.Upload = Upload;
    this.toaster = toaster;

    this.newSaver = {
      modelGroups: []
    };
  }

  $onInit() {
    this.getList();
  }

  upload(files) {
    this.toaster.pop({
      type: 'wait',
      title: '正在上传，请稍等...',
      timeout: 3000 * 1000
    });

    let upload = this.Upload.upload({
      url: '/api/screenSavers',
      arrayKey: '',
      data: Object.assign({files: files}, this.newSaver),
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    upload.progress((evt) => {
      progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
    });

    upload.success((data, status, headers, config) => {
      this.toaster.clear();
      this.toaster.pop('success', '上传成功');
      this.$state.go('screensavers.list');
    });

    upload.error((err) => {
      this.toaster.clear();
      this.toaster.pop('error', '上传失败', JSON.stringify(err));
    });
  }

  getList() {
    this.$http.get('/api/AppConfGroups').then(res => {
      this.groups = res.data;
    });
  }

  toggleSelection(id) {
    let idx = this.newSaver.modelGroups.indexOf(id);
    if (idx > -1) {
      this.newSaver.modelGroups.splice(idx, 1);
    } else {
      this.newSaver.modelGroups.push(id);
    }
  }

}



// WEBPACK FOOTER //
// ./client/app/screenSaver/add/add.controller.js